import axios from 'axios';
import {forEach as _forEach} from "lodash";

export const F_UPLOAD = 'F_UPLOAD';
export const CREATE_FOLDER = 'CREATE_FOLDER';
export const GET_MEDIA_LIBRARY = 'GET_MEDIA_LIBRARY';
export const GET_MEDIA_LIBRARY_FOLDER = 'GET_MEDIA_LIBRARY_FOLDER';
export const GET_MEDIA_LIBRARY_FOLDER_SORTED = 'GET_MEDIA_LIBRARY_FOLDER_SORTED';
export const EDIT_FILE = 'EDIT_FILE';
export const DELETE_FILE = 'DELETE_FILE';
export const DELETE_FOLDER = 'DELETE_FOLDER';
export const EDIT_FOLDER = 'EDIT_FOLDER';
export const CONNECT_TO_PIXABAY = 'CONNECT_TO_PIXABAY';
export const SET_VARIABLES_MEDIA = 'SET_VARIABLES_MEDIA';
export const UPDATE_STORE = "UPDATE_STORE"

/* Test */

export function uploadFile(formData, uploadProgress, filesToUpload) {
  return {
    type: F_UPLOAD,
    payload: axios.post('/api/medialibraries/files.json', formData, uploadProgress).then(({ data }) => {
      data.files = filesToUpload;
      return data;
    }),
  };
}

export function createFolder(data) {
  return {
    type: CREATE_FOLDER,
    payload: axios.post('/api/medialibraries/folders.json', data).then(({ data }) => data),
  };
}

export function getMediaLibrary(client, sort, access, username, includePdfFiles = false) {
  if(typeof client === "undefined"){
    client='';
  }

  let dir = "asc";
  if(sort === "cdateDESC"){
    sort = "cdate";
    dir="desc";
  } else if(sort === "cdateASC"){
    sort = "cdate";
    dir="asc";
  }

  let owner = "filters%5Bowner%5D%5B%5D=" + username + "&filters%5Bowner%5D%5B%5D=" + client;
  _forEach(access, (ancestor, i) => {
    owner = owner + "&filters%5Bowner%5D%5B%5D=" + ancestor;
  });

  return {
    type: GET_MEDIA_LIBRARY,
     payload: axios.get(`/api/medialibraries/main.json?sort=${sort}&dir=${dir}&${owner}&includePdfFiles=${includePdfFiles}`).then(({ data }) => data),

  };
}

export function getMediaLibraryFolder(client, folderId, sort, access, username) {
  if(typeof client === "undefined"){
    client='';
  }

  let dir = "asc";
  if(sort === "cdateDESC"){
    sort = "cdate";
    dir="desc";
  } else if(sort === "cdateASC"){
    sort = "cdate";
    dir="asc";
  }
  let owner = "filters%5Bowner%5D%5B%5D=" + username + "&filters%5Bowner%5D%5B%5D=" + client;
  _forEach(access, (ancestor, i) => {
    owner = owner + "&filters%5Bowner%5D%5B%5D=" + ancestor;
  });
  if(folderId === "main"){
    return {
      type: GET_MEDIA_LIBRARY_FOLDER,
      payload: axios.get(`/api/medialibraries/` + folderId + `.json?sort=${sort}&dir=${dir}&${owner}`).then(({ data }) => data),
    };
  }else{
    return {
      type: GET_MEDIA_LIBRARY_FOLDER,
      payload: axios.get(`/api/medialibraries/` + folderId + `.json?sort=${sort}&dir=${dir}`).then(({ data }) => data),
    };
  }
}

export function getMediaLibraryFolderSorted(client, folderId, sort, access, username) {

  if(typeof client === "undefined"){
    client='';
  }

  let dir = "asc";
  if(sort === "cdateDESC"){
    sort = "cdate";
    dir="desc";
  } else if(sort === "cdateASC"){
    sort = "cdate";
    dir="asc";
  }
  let owner = "filters%5Bowner%5D%5B%5D=" + username + "&filters%5Bowner%5D%5B%5D=" + client;
  _forEach(access, (ancestor, i) => {
    owner = owner + "&filters%5Bowner%5D%5B%5D=" + ancestor;
  });

  if(folderId === "main"){
    return {
      type: GET_MEDIA_LIBRARY_FOLDER_SORTED,
      payload: axios.get(`/api/medialibraries/` + folderId + `.json?sort=${sort}&dir=${dir}&${owner}`).then(({ data }) => data),
    };
  }else{
    return {
      type: GET_MEDIA_LIBRARY_FOLDER_SORTED,
      payload: axios.get(`/api/medialibraries/` + folderId + `.json?sort=${sort}&dir=${dir}`).then(({ data }) => data),
    };
  }


}


export function editFile(data) {
  return {
    type: EDIT_FILE,
    payload: axios.put('/api/medialibraries/' + data.id + '/file.json', data.data).then(({ data }) => data),
  };
}

export function deleteFile(id) {
  return {
    type: DELETE_FILE,
    payload: axios.delete('/api/medialibraries/' + id + '/files/toTrash.json').then(({ data }) => data),
  };
}

export function _deleteFolder(id) {
  return {
    type: DELETE_FOLDER,
    payload: axios.delete('/api/medialibraries/' + id + '/folders/toTrash.json').then(({ data }) => data),
  };
}

export function editFolder(data) {
  return {
    type: EDIT_FOLDER,
    payload: axios.put('/api/medialibraries/' + data.id + '/folder.json', data.data).then(({ data }) => data),
  };
}

export function setVariables(key){
  return{
    type: SET_VARIABLES_MEDIA,
    payload: key,
  }
}

export function updateStoreFR(data){
  return {
    type: UPDATE_STORE,
    payload: data,
  };
}

/*
 * NEEDS TO IMPLEMENT IN THE FUTURE
 */

export function connectToPixabay(key, searching, min_height, min_width) {
  const perPage = 'per_page=30'; //results per Page - default:20
  const page = 'page=1'; // returned search results are pagineted - default 1
  //more settings at https://pixabay.com/api/docs/#api_javascript_example

  let mixedData = [];

return {
 type: CONNECT_TO_PIXABAY,
  payload: axios.get(
   'https://pixabay.com/api/?key=' +
      key +
      '&q=' +
       encodeURIComponent(searching) +
       '&' +
      page +
      '&' +
       perPage +
       '&min_height=' +
       min_height +
        '&min_width=' +
       min_width
    ).then(({ data }) => {
      mixedData.push(searching)
      mixedData.push(data);
      return mixedData;
    }),
 };
 }
